<template>
    <div class="menu"
         v-bind:expanded="expanded">
        <div class="menu__main">
            <menu class="menu__left">
                <li v-for="date in dates"
                    v-bind:key="date.index">
                    <a v-bind:href="'#' + date.index"
                       v-bind:selected="date.index === dateIndex"
                       class="menu__button">
                        {{date.label}}
                    </a>
                </li>
            </menu>

            <menu class="menu__right">
                <li>
                    <button
                       v-on:click="expanded = !expanded"
                       class="menu__button menu__button--outlined">
                        Filter
                        <span v-if="isFiltered">*</span>
                    </button>
                </li>
            </menu>
        </div>

        <menu class="menu__expanded"
              v-show="expanded">
            <li class="menu__option">
                <input-toggle
                    class="menu__toggle"
                    v-model="pastevents"></input-toggle>

                <button
                    class="menu__button menu__button--link"
                    v-on:click="pastevents = !pastevents">Toon afgelopen</button>
            </li>

            <li class="menu__option">
                <input-toggle
                    class="menu__toggle"
                    v-model="onlyfree"></input-toggle>
                <button
                    class="menu__button menu__button--link"
                    v-on:click="onlyfree = !onlyfree">Alleen gratis</button>
            </li>

            <li class="menu__optionlabel">
                Toon evenementen van
            </li>

            <li class="menu__option"
                v-for="(origin, id) in origins">
                <input-toggle
                    class="menu__toggle"
                    v-model="origin.enabled"></input-toggle>

                <button
                    class="menu__button menu__button--link"
                    v-on:click="toggleOrigin(origin)">
                    {{origin.label}}
                </button>
            </li>

            <li class="menu__option">
                <button
                    class="menu__button menu__button--link"
                    v-on:click="toggleOrigins()">
                    {{toggleOriginsLabel}}
                </button>
            </li>
        </menu>
    </div>
</template>

<script>
    import InputToggle from './input-toggle.vue';
    import { mapGetters, mapState } from 'vuex';

    export default {
        components : { InputToggle },

        computed : {
            ...mapGetters(['allOriginsEnabled', 'date', 'dates']),
            ...mapState(['dateIndex', 'origins']),

            isFiltered() {
                return !this.allOriginsEnabled ||
                       this.$store.state.showPastEvents ||
                       this.$store.state.onlyFreeEvents;
            },

            pastevents : {
                get() {
                    return this.$store.state.showPastEvents;
                },

                set(bool) {
                    this.$store.commit('showPastEvents', bool);
                }
            },

            toggleOriginsLabel() {
                if (this.allOriginsEnabled) {
                    return 'Deselecteer alles';
                } else {
                    return 'Selecteer alles';
                }
            }
        },

        data() {
            return {
                expanded : false,
                onlyfree : this.$store.state.onlyFreeEvents
            };
        },

        methods : {
            toggleOrigin(origin) {
                this.$store.commit('toggleOrigin', origin.id);
            },

            toggleOrigins() {
                const enabled = this.allOriginsEnabled;
                this.$store.commit('setAllOriginsEnabled', !enabled);
            }
        },

        mounted() {
            // Clicking anywhere outside the menu closes the menu as well
            document.addEventListener('click', (e) => {
                const inMenu = this.$el.contains(e.target);

                if (!inMenu && this.expanded) {
                    this.expanded = false;
                }
            });
        },

        watch : {
            onlyfree(bool) {
                this.$store.commit('onlyFreeEvents', bool);
            }
        }
    }
</script>